import {
  get,
  merge,
  keys,
  isEmpty,
  map,
  includes,
  mapValues,
  has,
} from "lodash"

import { easyDecrypt, easyEncrypt } from "./encrypt"
import { config } from "config/config"
import { SAVE_AUTH_TEXT_FLAG } from "config/const"
import { APIResponse } from "redux/apis/types"
import { CheckHasProperties } from "utils/util"

const TW_STORAGE_LOCAL = "localStorage"
const TW_STORAGE_SESSION = "sessionStorage"

const _getItem = (
  key: string,
  empty: any = null,
  storage: string = TW_STORAGE_LOCAL
) => {
  try {
    const windowStorage = get(window, storage, false)
    if (!windowStorage) return empty
    const item = windowStorage.getItem(key)
    return !item ? empty : JSON.parse(item)
  } catch (e) {
    return empty
  }
}

const _setItem = (
  key: string,
  value: string | number | object | Array<object>,
  isMerge: boolean = false,
  storage = TW_STORAGE_LOCAL
) => {
  const windowStorage = get(window, storage)
  if (!windowStorage) return
  if (isMerge) {
    const origin = _getItem(key, null, storage)
    value = merge(origin, value)
  }
  windowStorage.setItem(key, JSON.stringify(value))
}

const _getKeys = (storage: string = TW_STORAGE_LOCAL) =>
  keys(get(window, storage))

// const _getPrefixList = (prefix: string, storage: string = TW_STORAGE_LOCAL) =>
//   _getKeys(storage).filter(a => startsWith(a, prefix))
//
// const _removePrefixList = (key: string, storage: string = TW_STORAGE_LOCAL) => {
//   const windowStorage = get(window, storage)
//   if (!windowStorage) return
//   windowStorage.removeItem(key)
// }

const _removeItem = (key: string, storage: string = TW_STORAGE_LOCAL) => {
  const windowStorage = get(window, storage)
  if (!windowStorage) return
  windowStorage.removeItem(key)
}
//
// const _removeAll = (storage: string = TW_STORAGE_LOCAL) => {
//   const windowStorage = get(window, storage)
//   if (!windowStorage) return
//   windowStorage.clear()
// }

//以下サンプル
export const UserStorage = {
  User: {
    get: () => _getItem("user_info", {}, TW_STORAGE_SESSION),
    getSessionId: () => {
      const user_info = _getItem("user_info", {}, TW_STORAGE_SESSION)
      return get(user_info, "SessionID", "")
    },
    set: (data: APIResponse.Res, merge: boolean = false) =>
      _setItem("user_info", data, merge, TW_STORAGE_SESSION),
    clear: () => _removeItem("user_info", TW_STORAGE_SESSION),
  },
  PasswordSetting: {
    get: () =>
      _getItem(
        "password_setting",
        SAVE_AUTH_TEXT_FLAG.Disabled.id,
        TW_STORAGE_SESSION
      ),
    set: (bool: boolean) =>
      _setItem(
        "password_setting",
        bool ? SAVE_AUTH_TEXT_FLAG.Enabled.id : SAVE_AUTH_TEXT_FLAG.Disabled.id,
        false,
        TW_STORAGE_SESSION
      ),
  },
  Ranking: {
    get: () => _getItem("ranking_setting", {}, TW_STORAGE_LOCAL),
    set: (data: Array<number> | {}) => _setItem("ranking_setting", data),
  },
  ForeignRanking: {
    get: () => _getItem("foreign_ranking_setting", {}, TW_STORAGE_LOCAL),
    set: (data: Array<number> | {}) =>
      _setItem("foreign_ranking_setting", data),
  },
  ChartSession: {
    get: () => {
      return _getItem("chart_session", null, TW_STORAGE_LOCAL)
    },
    set: (data: object) => {
      _setItem("chart_session", data, false, TW_STORAGE_LOCAL)
    },
  },
  ChartColor: {
    get: () => {
      return _getItem("chart_color", null, TW_STORAGE_SESSION)
    },
    set: (data: object) => {
      _setItem("chart_color", data, false, TW_STORAGE_SESSION)
    },
  },
  ChartSetting: {
    get: () => {
      return _getItem("chart_setting", null, TW_STORAGE_LOCAL)
    },
    set: (data: object) => {
      _setItem("chart_setting", data, false, TW_STORAGE_LOCAL)
    },
  },
  TechChartColor: {
    getWhite: () => {
      return _getItem("tech_chart_color_white", null, TW_STORAGE_LOCAL)
    },
    getDark: () => {
      return _getItem("tech_chart_color_Dark", null, TW_STORAGE_LOCAL)
    },
    setWhite: (data: object) => {
      _setItem("tech_chart_color_white", data, false, TW_STORAGE_LOCAL)
    },
    setDark: (data: object) => {
      _setItem("tech_chart_color_Dark", data, false, TW_STORAGE_LOCAL)
    },
  },
  TechChart: {
    get: () => {
      return _getItem("tech_chart", null, TW_STORAGE_LOCAL)
    },
    set: (data: object) => {
      _setItem("tech_chart", data, false, TW_STORAGE_LOCAL)
    },
    remove: () => {
      _removeItem("tech_chart")
    },
  },
  ThemeColor: {
    get: () => {
      return _getItem("theme_color", null, TW_STORAGE_LOCAL)
    },
    set: (data: string) => {
      _setItem("theme_color", data, false, TW_STORAGE_LOCAL)
    },
    remove: () => {
      _removeItem("theme_color")
    },
  },
  SelectCountry: {
    get: () => {
      return _getItem("select-country", null, TW_STORAGE_LOCAL)
    },
    set: (data: Array<string>) => {
      _setItem("select-country", data, false, TW_STORAGE_LOCAL)
    },
  },
  searchHistory: {
    get: () => {
      return _getItem("search-history", null, TW_STORAGE_LOCAL)
    },
    set: (
      data: Array<
        | {
            Symbol: string
            SymbolName: string
            SymbolNameS: string
            Exchange: number
            SecurityType: number
            Ticker: string
          }
        | { keyword: string }
        | {}
      >
    ) => {
      _setItem("search-history", data, false, TW_STORAGE_LOCAL)
    },
    remove: () => {
      _removeItem("search-history")
    },
    cheackData: (data: Array<object>) => {
      if (isEmpty(data)) return false
      const res = map(data, items => {
        if (
          !CheckHasProperties(items, [
            "Symbol",
            "SymbolName",
            "SymbolNameS",
            "Exchange",
            "SecurityType",
            "Ticker",
            "NumberOfDecimals",
          ]) &&
          !has(items, "keyword")
        )
          return false
        return true
      })
      return !includes(res, false)
    },
  },
  symbolDetail: {
    get: () => {
      return _getItem("symbol_detail", null, TW_STORAGE_LOCAL)
    },
    set: (data: object) => {
      _setItem("symbol_detail", data, false, TW_STORAGE_LOCAL)
    },
    remove: () => {
      _removeItem("symbol_detail")
    },
  },
  sessionTimeout: {
    get: () => {
      return _getItem("session_timeout", null, TW_STORAGE_LOCAL)
    },
    set: (data: object) => {
      _setItem("session_timeout", data, false, TW_STORAGE_LOCAL)
    },
  },
  loginInfo: {
    get: () => {
      const data = _getItem("login-info", null, TW_STORAGE_LOCAL)
      const save_flag = get(data, "save_flag")
      return {
        ...mapValues(data, items => {
          if (typeof items === "boolean") return items
          return easyDecrypt(items)
        }),
        save_flag,
      }
    },
    set: (data: {
      branch?: string | null
      id?: string | null
      pass?: string | null
      save_flag?: boolean
    }) => {
      const _data = mapValues(data, items => {
        if (typeof items === "boolean") return items
        return easyEncrypt(items)
      })
      _setItem("login-info", _data, false, TW_STORAGE_LOCAL)
    },
    remove: () => {
      _removeItem("login-info")
    },
    cheackData: (data: object) => {
      return CheckHasProperties(data, ["branch", "id", "pass"])
    },
  },
  registerSheet: {
    get: () => _getItem("register_sheet", {}, TW_STORAGE_LOCAL),
    set: (data: { sheet: number } | {}) => _setItem("register_sheet", data),
  },
  registerTag: {
    get: () => _getItem("register_tag", {}, TW_STORAGE_LOCAL),
    set: (data: { tag: string } | {}) => _setItem("register_tag", data),
  },
}
